// AkciiSlyder.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Container, Image } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import styles from './../style/AkciiSlyder.module.scss';

import PromotionIcon from '../icons/PromotionIcon';
import SwiperArrowLeft from '../icons/SwiperArrowLeft';
import SwiperArrowRight from '../icons/SwiperArrowRight';

class AkciiSlyder extends React.Component {
  constructor(props) {
    super(props);
    this.swiperRef = React.createRef();
    this.nextSlide = this.nextSlide.bind(this);
    this.prevSlide = this.prevSlide.bind(this);
  }

  nextSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slideNext();
    }
  }

  prevSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slidePrev();
    }
  }

  render() {
    const { page_data, slydes, hidetitle } = this.props;

    return (
      <section className={styles.testimonialsSection}>
        <Container className={styles.container}>
          {!hidetitle &&
            <div className={styles.sectionHeader}>
              <div className={styles.titleWrapper}>
                <h2 className={styles.sectionTitle}>Акции</h2>
                <PromotionIcon />
              </div>
              <a href={page_data?.link_akcii} className={styles.viewAll}>Смотреть все →</a>
            </div>
          }
          
          <div className={styles.sliderContainer}>
            <Swiper
              ref={this.swiperRef}
              modules={[Navigation]}
              spaceBetween={10}
              slidesPerView={4}
              loop={true}
              autoHeight={false}
              observer={false}
              resizeObserver={false}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10
                },
                576: {
                  slidesPerView: 3,
                  spaceBetween: 10
                },
                992: {
                  slidesPerView: 4,
                  spaceBetween: 10
                }
              }}
            >
              {slydes.map((slyde) => (
                <SwiperSlide key={slyde.id}>
                  <div className={styles.slyde}>
                    <Image className={styles.slyde_image} src={slyde?.image} alt={slyde?.pagetitle} width={257} height={158} />
                    <a href={slyde?.href} className={styles.slyde_name + ` stretched-link`}>{slyde?.pagetitle}</a>
                    <div className={styles.slyde_text}>{slyde?.introtext}</div>
                    <div className={styles.slyde_text2}>{slyde?.description}</div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className={styles.swiperControls}>
              <button 
                className={`${styles.swiperButton} ${styles.swiperButtonPrev} d-none`}
                onClick={this.prevSlide}
              >
                <SwiperArrowLeft />
              </button>
              <button 
                className={`${styles.swiperButton} ${styles.swiperButtonNext}`}
                onClick={this.nextSlide}
              >
                <SwiperArrowRight />
              </button>
            </div>
          </div>
        </Container>
      </section>
    );
  }
}

AkciiSlyder.propTypes = {
  page_data: PropTypes.object,
  slydes: PropTypes.array,
  hidetitle: PropTypes.bool
};

AkciiSlyder.defaultProps = {
  page_data: {},
  slydes: [],
  hidetitle: false
};

export default AkciiSlyder;
